export default "__VITE_ASSET__CKlXbLuB__"